import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

export const Wrapper = styled.div<{ tinted?: boolean }>`
    background-color: ${theme.colors.grey1};
`;

export const Title = styled.h1`
    margin-bottom: ${theme.space[4]}px;
    font-family: ${theme.fonts.bold};
    font-size: 3.2rem;
    line-height: 2.4rem;
    text-align: start;
    text-transform: none;
    color: ${theme.colors.primaryBlack};

    @media ${getBreakpoint("up", "lg")} {
        font-size: 7rem;
        line-height: 6.5rem;
    }
`;
